import React, { useContext, useEffect } from "react";
import { UserContext } from "../context/MainContext";
import { useNavigate } from "react-router-dom";

const AuthRoute = ({ children }) => {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) {
      navigate("/login", { replace: true });
    }
  }, [user, navigate]);

  return user ? <>{children}</> : null;
};

export default AuthRoute;
